<template>
    <v-col class="pa-0" cols="12">
        <v-card elevation="1" class="background-2 round-card">
            <v-card-title class="pa-3">
                <p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Dati SMTP Standard</p>
                <v-spacer></v-spacer>
            </v-card-title>                 
            <v-divider></v-divider>
            <v-container class="pa-0 pt-4" fluid>
                <v-row class="pa-4">
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="text"
                            label="Host"
                            v-model="settings['mail_host']"
                            :error-messages="errors.collect('Host')"
                            :data-vv-name="'Host'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="number"
                            label="Porta"
                            v-model.number="settings['mail_port']"
                            :error-messages="errors.collect('Porta')"
                            :data-vv-name="'Porta'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="text"
                            label="Nome utente"
                            v-model="settings['mail_username']"
                            :error-messages="errors.collect('Nome utente')"
                            :data-vv-name="'Nome utente'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            label="Password"
                            v-model="settings['mail_password']"
                            :error-messages="errors.collect('Password')"
                            :data-vv-name="'Password'"
                            outlined
                            dense
                            :append-icon="e1 ? 'visibility' : 'visibility_off'"
                            @click:append="() => {e1 = !e1}"
                            :type="!e1 ? 'password' : 'text'"
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-select
                            label="Crittografia"
                            :items="[
                                {
                                    'text': 'SSL',
                                    'value': 'ssl'
                                },
                                {
                                    'text': 'TLS',
                                    'value': 'tls'
                                },
                                {
                                    'text': 'Nessuna',
                                    'value': null
                                }
                            ]"
                            v-model="settings['mail_encryption']"
                            :error-messages="errors.collect('Crittografia')"
                            :data-vv-name="'Crittografia'"
                            :menu-props="{'offset-y': true}"
                            outlined
                            dense
                        ></v-select>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="text"
                            label="Mail Mittente"
                            v-model="settings['mail_from_address']"
                            :error-messages="errors.collect('Mail Mittente')"
                            :data-vv-name="'Mail Mittente'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="text"
                            label="Nome Mittente"
                            v-model="settings['mail_from_name']"
                            :error-messages="errors.collect('Nome Mittente')"
                            :data-vv-name="'Nome Mittente'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                        <v-text-field
                            type="text"
                            label="CC Fisso"
                            hint="Tutte le mail in uscita da GiveMeHive avranno questo CC"
                            v-model="settings['static_cc']"
                            :error-messages="errors.collect('CC Fisso')"
                            :data-vv-name="'CC Fisso'"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions class="pr-4">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
            </v-card-actions>
                    
        </v-card>
    </v-col>
</template>

<script>

    import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'standard-smtp',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'smtp',
                settings: {
                    'mail_host': '',
                    'mail_port': '',
                    'mail_username': '',
                    'mail_password': '',
                    'mail_encryption': '',
                    'mail_from_address': '',
                    'mail_from_name': '',
                    'static_cc': '',
                },
                e1: false
            }
        },
    }
</script>

<style scoped>

</style>